  <template>
  <v-container>
    <div class="mt-4">
      <h1 class="text-center">Connexion</h1>
      <div class="d-flex">
        <v-spacer/>
        <form
          ref="form"
          method="POST"
          action="/oauthlogin"
          class="login"
        >
          <v-card-text>
            <v-alert v-if="msg" :type="msgType">
              <template v-if="invalidLogin">
                <div>Identifiant ou mot de passe invalide.</div>
                <div><em>En cas de problème technique merci de contacter le support EPELFI.</em></div>
              </template>
            </v-alert>

            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  name="username"
                  label="Identifiant"
                  v-model="username"
                  filled
                  hide-details
                  data-testid="identifiant"
                />
              </v-col>
              <v-col cols="12">
                <a-motpasse-field
                  @keydown.enter="login"
                  name="password"
                  label="Mot de passe"
                  v-model="password"
                  filled
                  data-testid="mot-de-passe"
                />
                <router-link :to="{name:'motpasseoublie'}">Mot de passe oublié ?/Finaliser mon inscription</router-link>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text class="d-flex">
            <router-link :to="{name:'creationcompte'}">Créer un compte</router-link>
            <v-spacer />
            <v-btn data-testid="se-connecter" @click="login" :disabled="!loggable" color="primary">
              Se connecter
            </v-btn>
          </v-card-text>
        </form>
        <v-spacer/>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      username: "",
      password: "",
      msg: null,
      msgType: null,
    };
  },

  mounted() {
    //gestion des operations et des messages
    var href = window.location.href;
    if (href.endsWith("?error")) {
      this.msg = "invalidLogin";
      this.msgType = "error";
    }

    if(this.email!==null) {
      this.username = this.email;
    }
  },

  computed: {
    loggable() {
      return this.username !== "" && this.password !== "";
    },
    invalidLogin: function () {
      return this.msg == "invalidLogin";
    },
  },

  methods: {
    login() {
      this.$refs.form.submit();
    },
  },
};
</script>
